/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExceptionResponseDTO } from './exception-response-dto';
import { ExceptionResponseWithResiduoDTO } from './exception-response-with-residuo-dto';
import { VoucherDisambiguazioneItemDTO } from './voucher-disambiguazione-item-dto';
import { ExceptionResponseWithVoucherListDTO } from './exception-response-with-voucher-list-dto';


/**
 * @type GetProfiloServizio409Response
 * @export
 */
export type GetProfiloServizio409Response = ExceptionResponseDTO | ExceptionResponseWithResiduoDTO | ExceptionResponseWithVoucherListDTO;

